import { FC, ReactNode, SyntheticEvent } from 'react';

import { Link } from 'shared/components/InteractiveTypography';

import { WrapElementsSpacer } from '../WrapElementsSpacer';

import styles from './SpecialGeo.css';

type SpecialGeoProps = {
  url: string;
  name: string;
  icon: ReactNode;
  remoteness: string;
  remotenessIcon: ReactNode;
  trackClick(): void;
  onClick?(e: SyntheticEvent<HTMLElement>): void;
};

export const SpecialGeo: FC<SpecialGeoProps> = props => {
  const { icon, name, url, remoteness, remotenessIcon, onClick, trackClick } = props;

  return (
    <div className={styles['container']}>
      <WrapElementsSpacer horizontalSpace={4} verticalSpace={0} wrapItems={false}>
        {icon}
        <Link behaviour="hover_black_to_primary" href={url} track={trackClick} onClick={onClick}>
          {name}
        </Link>
      </WrapElementsSpacer>
      <WrapElementsSpacer horizontalSpace={4} verticalSpace={0} wrapItems={false}>
        {remotenessIcon}
        {remoteness}
      </WrapElementsSpacer>
    </div>
  );
};
